<script>
export default {
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'success',
      validator: function (value) {
        return ['success', 'warning', 'danger', 'info', 'finish', 'semi-success-warning', 'secondary', 'secondary-light'].indexOf(value) !== -1
      },
    },
    round: {
      type: Boolean,
      default: false,
    },
    borderNone: {
      type: Boolean,
      default: false
    },
    textW: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  }
}
</script>

<template>
  <span :class="[
    $style.label, $style[`label--${state}`],
    {
      [$style['label--text']]: text,
      [$style['label--dot']]: dot,
      [$style['label--round']]: round,
      [$style['label--none']]: borderNone,
      [$style['label--textW']]: textW,
    },
    {
      [$style['orderDetailSize']]: false,
    },
  ]">
    <slot></slot>
  </span>
</template>

<style lang="scss" module>

$type-state-map: (
  success: #12C494,
  danger: #F25555,
  info: $color-text-light,
  warning: #F0A682,
  finish: #A3DAE6,
  semi-success-warning: linear-gradient($color-state-success 50%, $color-state-warning 50%),
  secondary: $color-secondary,
  secondary-light: $color-secondary-light
);

.label {
  box-sizing: border-box;
  // border-radius: 8px;
  display: inline-block;
  font-weight: bold;
  letter-spacing: $font-letter-spacing-small;
  white-space: nowrap;
  font-weight: 400;

  &+& {
    margin-left: 10px;
  }

  @each $state,
  $color in $type-state-map {
    &--#{$state} {
      color: $color;

      // background: $color; 取消背景色
      // border: 1px solid $color;
      &:global {
        &.is-border {
          border: 1px solid $color;
        }

        &.is-round {
          border-radius: 8px;
        }
      }

      // 特殊樣式：為顏色底、白色文字
      &.label--textW {
        color: white;
        background: $color;
      }

      &.label--text {
        color: $color;
        background: transparent;
      }

      &.label--dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }

      &.label--none {
        display: flex;
        justify-content: center;
        border: none;
      }

      &.label--round {
        padding: 4px 10px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
        line-height: 23px;
        // @if $state == 'success' {
        //   background-color: lighten($color, 37%);
        // }
        // @if $state == 'danger' {
        //   background-color: lighten($color, 30%);
        // }
        // @if $state == 'info' {
        //   background-color: lighten($color, 35%);
        // }
        // @if $state == 'warning' {
        //   background-color: lighten($color, 35%);
        // }
        // @if $state == 'finish' {
        //   background-color: lighten($color, 50%);
        // }
      }

      &:not(.label--text):not(.label--dot) {
        height: 30px;
        padding: 2px 10px;
        font-size: $font-size-smaller;
        line-height: 25px;
        font-size: 14px;
      }
    }
  }
}
.orderDetailSize {
  height: 44px !important;
  width: 121px !important;
  line-height: 36px !important;
  text-align: center !important;

}
</style>
